import { useState } from 'react';
import './App.css';
import HomePageModern from './HomePageModern';
import ServicesPageModern from './ServicesPageModern';

function App() {
  const [currentPage, setCurrentPage] = useState('home');

  return (
    <div className="App">
      {currentPage === 'home'
        ? <HomePageModern onNavigate={setCurrentPage} currentPage={currentPage} />
        : <ServicesPageModern onNavigate={setCurrentPage} currentPage={currentPage} />}

      <footer className="footer">
        <div className="footer-content">
          <p className="footer-text">
            Designed & Developed by <a href="https://www.wildfiremedia.agency/" target="_blank" rel="noopener noreferrer" className="agency-link">Wildfire Media</a>
          </p>
          <p className="footer-powered">
            Powered by The ORDER
          </p>
        </div>
      </footer>
    </div>
  );
}

export default App;
